import Alpine from "alpinejs";
import Zoomable from "@benbjurstrom/alpinejs-zoomable";
import intersect from "@alpinejs/intersect";
import focus from "@alpinejs/focus";
import lazySizes from "lazysizes";
import lightGallery from "lightgallery";
window.lightGallery = lightGallery;
import lgVideo from "lightgallery/plugins/video";
window.lgVideo = lgVideo;
import flatpickr from "flatpickr";
import { French } from "flatpickr/dist/l10n/fr.js";
import { German } from "flatpickr/dist/l10n/de.js";

import "./global.js";
import "./components/heading-order.js";
import "./components/iframe-title.js";
import "./components/pdf.js";
import "./components/mobileNativeSharing.js";
import "./components/blog-listing-carousel.js";
import "./components/blog.js";
import "./components/tours.js";
import "./components/agenda.js";
import "./components/press.js";
import "./components/medias.js";
import "./components/search_v2.js";
import "./components/form-sitc.js";
import "./components/form-submit-photo.js";
import "./components/map-luxembourgcity.js";
import "leaflet-routing-machine/dist/leaflet-routing-machine.css";
import blogListFilter from "./components/blog-listing.js";
import darkMode from "./components/darkMode.js";

// import "./components/maps.js";

window.Alpine = Alpine;
Alpine.plugin(Zoomable);
Alpine.plugin(intersect);
Alpine.plugin(focus);

// IMPORTANT: Écouter l'événement AVANT de démarrer Alpine
document.addEventListener("alpine:init", () => {
  console.log("AlpineJS ready!");
  console.log("AlpineJS 2 ready!");
  Alpine.data("blogListFilter", blogListFilter);
  Alpine.data("darkMode", darkMode);
});

// Démarrer Alpine APRÈS avoir configuré les listeners
Alpine.start();

console.log("AlpineJS started!");
